import ENG from './en';
import IDN from './id';
import ITA from './it';

export const LANG = {
    en: ENG,
    id: IDN,
    it: ITA
}